import jQuery from 'jquery';

import { refreshWaypointInstances } from '../../../animation/refresh-waypoint-instances';
import { type TriggerAnimationsForElementsOptions } from '../../types';

/**
 * Trigger animations for elements when they become visible.
 *
 * @param {JQuery} $elements Elements to animate.
 * @param {TriggerAnimationsForElementsOptions} options Optional callbacks to gate deferred triggers.
 */
export const triggerAnimationsForElements = (
  $elements: JQuery,
  options?: TriggerAnimationsForElementsOptions,
): void => {
  if ('function' !== typeof window.et_animate_element) {
    return;
  }

  const shouldTrigger = options?.shouldTrigger ?? (() => true);

  $elements.each((index, elem) => {
    const $elem = jQuery(elem);

    // Refresh waypoints if they exist (waypoints don't work for hidden elements).
    refreshWaypointInstances($elem);

    // Trigger animation if element is visible and hasn't been animated yet.
    setTimeout(() => {
      if (!shouldTrigger()) {
        return;
      }

      if ($elem.is(':visible') && !$elem.hasClass('et_had_animation')) {
        window.et_animate_element($elem);
      }
    }, 0);
  });
};
